/**
 * @desc 导出公司ComeOnDetail统计列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.CompanyComeOnStatisticalSubsidiaryConditions): Promise<BaseResponse<any>> {
  return fetch({
    url: config.API_HOST + '/statistics/exportCompanyDetail',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
